export default {
	state: {
		//搜索表单
		productionOrderParams: {
			materielName: null,
			materielCode: null
		}
	},
	mutations: {},
	actions: {},
	getters: {},
}
